<template>
  <article :class="wrapClass">
    <div class="cursor cursor--small"></div>
    <canvas class="cursor cursor--canvas" resize></canvas>
    <IntroBox :trigger="trigger"/>
  </article>
</template>

<script>
import IntroBox from '@/components/IntroBox/IntroBox';
import SplitText from '@/components/SplitText/SplitText';
import Promo from '@/components/Promo/Promo';
import Office from '@/components/Office/Office';
import About from '@/components/About/About';
import People from '@/components/People/People';
import Footer from '@/components/Footer/Footer';
import './style.scss';
import mouse from '@/utils/mouse';
import ismobile from '@/utils/ismobile';

export default {
  name: 'FrontPage',
  data() {
    return {
      wrapClass: 'wrap',
    };
  },
  components: {
    IntroBox,
    SplitText,
    Promo,
    Office,
    About,
    People,
    Footer,
  },
  mounted() {
    !ismobile() && mouse();
    setTimeout(() => {
      this.wrapClass = 'wrap loaded';
    }, 400);
  },
  methods: {
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/containers/FrontPage/FrontPage.vue